import Api from "./Api";

class FormulaTableService {
    getAllFormulas = async formulaType => {
        return await Api().get("formula", {
            params: {
                "request-data-type": "formulas",
                "request-formula-type": formulaType
            }
        });
    };

    getColors = async () => {
        return await Api().get("formula", { params: { "request-data-type": "colors" } });
    };

    getFormulaTargets = async formulaType => {
        return await Api().get("formula", {
            params: {
                "request-data-type": "formula_targets",
                "request-formula-type": formulaType
            }
        });
    };

    addNewFormula = async formulaData => {
        return Api().post("formula", {
            index: formulaData.index,
            formula: formulaData.formula,
            formula_target: formulaData.formulaTarget,
            color: formulaData.color,
            sensor_high: formulaData.sensorHigh,
            sensor_low: formulaData.sensorLow,
            soil_types: formulaData.soilType ? formulaData.soilType : [],
            countries: formulaData.country ? formulaData.country : [],
            start_date: formulaData.startDate,
            end_date: formulaData.endDate
        });
    };

    editFormula = async formulaData => {
        return Api().put("formula", {
            id: formulaData.id,
            index: formulaData.index,
            formula: formulaData.formula,
            formula_target: formulaData.formulaTarget,
            color: formulaData.color,
            sensor_high: formulaData.sensorHigh,
            sensor_low: formulaData.sensorLow,
            soil_types: formulaData.soilType ? formulaData.soilType : [],
            countries: formulaData.country ? formulaData.country : [],
            start_date: formulaData.startDate,
            end_date: formulaData.endDate
        });
    };

    deleteFormula = async formulaId => {
        return Api().delete("formula", {
            params: { id: formulaId }
        });
    };

    downloadFormulasCSV() {
        return Api().get(`/formula/download`);
    }
}

export default new FormulaTableService();
